module.exports = __webpack_public_path__ + "static/media/upload.21332af7.svg";